/**
 * @file 函数处理
 * @author dafo<huanghoujin@baijiahulian.com>
 */

/**
 * 防抖动
 *
 * @param {Function} fn 需要防抖动的函数
 * @param {?Object=} context 函数调用时的上下文
 * @return {Function} 包装过的支持防抖动函数
 */
export const debounce = (fn, delay, context) => {
    let timer = null;

    return function debounce() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }

        timer = setTimeout(fn, delay, context);
    };
};

/**
 * 节流
 *
 * @param {Function} fn 需要节流的函数
 * @param {?Object=} context 函数调用时的上下文
 * @return {Function} 包装过的支持节流函数
 */
export const throttle = (fn, delay, context) => {
    let lastCalledTime = +new Date();

    return function throttled() {
        const nowTime = +new Date();

        if (nowTime - lastCalledTime >= delay) {
            fn.call(context);
            lastCalledTime = nowTime;
        }
    };
};

/**
 * 在首部调用的节流函数
 * @param {Function} fn 需要节流的函数
 * @param {?number} delay 节流时间间隔
 * @param {?Object} context 函数上下文
 * @return 包装过的在首部调用的支持节流函数
 */
export const preThrottle = (fn, delay, context) => {
    let flag = true;

    return function preThrottled() {
        if (flag) {
            fn.call(context);
            flag = false;
            setTimeout(() => {
                flag = true;
            }, delay);
        }
    };
};
